import {validateField, submitFields, clearFields} from './helpers/form'
import {
  FETCH_PROFILE_ACTOR_DATA_SUCCESS,
  VALIDATE_PROFILE_ACTOR_FIELD,
  SUBMIT_PROFILE_ACTOR_FIELDS,
  CLEAR_PROFILE_ACTOR_FIELDS
} from '../../../actions/pages/profile-actor'

export function profileActor(
  state = {
    valid: false,
    fields: [
      {
        name: 'DirectorsComments',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: "Director's comments",
          required: false
        }
      }
    ]
  },
  action
) {
  switch (action.type) {
    case FETCH_PROFILE_ACTOR_DATA_SUCCESS: {
      let fields = state.fields.map((field) => {
        let newValue;
        Object.entries(action.data).forEach(([key, value]) => {
          if (field.name === key){
            newValue = value;
            return;
          }
        })

        if (newValue !== undefined) {
          return {
            ...field,
            value: newValue,
            errors: []
          }
        }

        return field;
      })

      return Object.assign({}, state, {
        valid: true,
        fields: Array.from(fields)
      })
    }

    case VALIDATE_PROFILE_ACTOR_FIELD: {
      return validateField(state, action);
    }

    case SUBMIT_PROFILE_ACTOR_FIELDS: {
      return submitFields(state, action);
    }

    case CLEAR_PROFILE_ACTOR_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
